<template>
    <div>
        <div class="search-filter mt-5 mb-0">
            <div class="container">
                <h2 class="text-blue mb-2">Search Website:</h2>
                <div class="row">
                    <!--
                    <div class="col-xs-12 col-md-4 col-xl-2">
                        <div class="select-topic">
                            <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Filter by
                                Topic <span class="caret"></span>
                            </button>
                            <div class="dropdown-menu" id="legend-topic">
                                <a
                                    class="dropdown-item"
                                    href="#"
                                    v-for="(category, index) in categories"
                                    :key="index"
                                    :data-prop="category.id"
                                >
                                    {{ category.text }}
                                </a>
                            </div>
                        </div>
                    </div>
                    -->
                    <div class="col-xs-12 col-md-12 col-xl-12">
                        <div class="atlas-search">
                            <div class="input-group">
                                <button id="search-button" type="button" class="btn btn-primary btn-sm" @click="submitSearch">
                                    <i class="fas fa-search"></i>
                                </button>
                                <input
                                    v-model="query"
                                    @input="submitSearch"
                                    @change="submitSearch"
                                    name="search-input"
                                    type="search"
                                    id="form1"
                                    class="form-control"
                                    placeholder="Search by Keyword"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <article>
            <section class="partner-section" v-if="searchResult && searchResult.length < 1">
                <div class="container">
                    <div class="row  align-items-center">
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <div class="section-body">
                                <h4 class="text-blue">not results found</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </article>
        <article>
            <section class="partner-section" v-if="searchResult && searchResult.length > 0" v-for="(result, index) in searchResult" :key="index">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-sm-12 col-md-6 col-lg-4">
                            <div class="article-img">
                                <img loading="lazy" width="200" height="150" :src="result._source._kit_image" :alt="result._source.post_title">
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-8">
                            <div class="section-body">
                                <h4 class="text-blue">{{ result._source.post_title }}</h4>
                                <p v-html="result._source._kit_text.substring(0, 320) + '...'"></p>
                            </div>
                            <div class="section-footer">
                                <a
                                    v-if="result._source.post_type === 'event'"
                                    :href="'/page/events/'+result._source.post_name"
                                    class="btn btn-blue"
                                    role="button"
                                    ontouchstart=""
                                    target="_self"
                                >
                                    Read more
                                </a>
                                <a
                                    v-if="result._source.post_type !== 'event'"
                                    :href="result._source._kit_url"
                                    class="btn btn-blue"
                                    role="button"
                                    ontouchstart=""
                                    target="_self"
                                >
                                    Read more
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </article>
    </div>
</template>

<script>

import elasticPressQuery from '../epas';
import {replaceGlobally} from '../utils/helpers';

export default {
    name: "SearchForm",

    data() {
        return {
            formIsLoading           : false,
            debounceFetchResults    : null,
            searchResult            : null,
            query                   : '',
            categories              : [
                { id: 'all', text: 'Show all' },
                { id: 'policy', text: 'Policy' },
                { id: 'collaboration', text: 'Collaboration' },
                { id: 'innovation', text: 'Innovation' },
                { id: 'entrepreneurship', text: 'Entrepreneurship' },
                { id: 'education', text: 'Education' },
                { id: 'research', text: 'Research' },
                { id: 'information', text: 'Information' },
            ],
        };
    },

    watch: {
        query(val, oldVal) {
            this.submitSearch();
        }
    },

    methods: {

        submitSearch() {

            clearTimeout(this.debounceFetchResults);

            this.debounceFetchResults = setTimeout(() => {
                this.fetchResults();
            }, 200);
        },

        getJsonQuery() {
            return elasticPressQuery.config;
        },

        getPostTypesFromForm() {
            return ['post', 'page', 'event', 'project'];
        },

        setFormIsLoading(value) {
            this.formIsLoading = value;
        },

        buildSearchQuery(searchText, placeholder, { query }) {
            return replaceGlobally(query, placeholder, searchText);
        },

        checkForOrderedPosts(hits, searchTerm) {
            const toInsert = {};
            const taxName = 'ep_custom_result';
            const lowerCaseSearchTerm = searchTerm.toLowerCase();

            const filteredHits = hits.filter((hit) => {
                // Should we retain this hit in its current position?
                let retain = true;

                if (undefined !== hit._source.terms && undefined !== hit._source.terms[taxName]) {
                    hit._source.terms[taxName].forEach((currentTerm) => {
                        if (currentTerm.name.toLowerCase() === lowerCaseSearchTerm) {
                            toInsert[currentTerm.term_order] = hit;

                            retain = false;
                        }
                    });
                }

                return retain;
            });

            const orderedInserts = {};

            Object.keys(toInsert)
                .sort()
                .forEach((key) => {
                    orderedInserts[key] = toInsert[key];
                });

            if (Object.keys(orderedInserts).length > 0) {
                Object.keys(orderedInserts).forEach((key) => {
                    const insertItem = orderedInserts[key];

                    filteredHits.splice(key - 1, 0, insertItem);
                });
            }

            return filteredHits;
        },

        async esSearch(query, searchTerm) {

            let config = this.getJsonQuery();

            const fetchConfig = {
                body    : query,
                method  : 'POST',
                mode    : 'cors',
                headers : {
                    'Content-Type': 'application/json; charset=utf-8',
                },
            };

            config.endpointUrl = '/cms/index.php?rest_route=/elasticpress/autosuggest';

            if (config?.http_headers && typeof config.http_headers === 'object') {
                Object.keys(config.http_headers).forEach((name) => {
                    fetchConfig.headers[name] = config.http_headers[name];
                });
            }

            // only applies headers if using ep.io endpoint
            if (config.addSearchTermHeader) {
                fetchConfig.headers['EP-Search-Term'] = encodeURI(searchTerm);
            }

            try {
                const response = await fetch(config.endpointUrl, fetchConfig);

                if (!response.ok) {
                    throw Error(response.statusText);
                }

                const data = await response.json();

                // allow for filtered data before returning it to
                // be output on the front end
                if (typeof window.epDataFilter !== 'undefined') {
                    return window.epDataFilter(data, searchTerm);
                }

                return data;
            }
            catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
                return error;
            }
        },

        async fetchResults() {
            // retrieves the PHP-genereated query to pass to ElasticSearch
            const queryJSON = this.getJsonQuery();

            if (queryJSON.error) {
                return;
            }

            const searchText  = this.query;
            const placeholder = 'ep_autosuggest_placeholder';
            const postTypes   = this.getPostTypesFromForm();

            if (searchText.length >= 2)
            {
                this.setFormIsLoading(true);

                if (postTypes.length > 0) {

                    if (typeof queryJSON.query.post_filter.bool.must !== 'undefined') {
                        queryJSON.query.post_filter.bool.must.push({
                            terms: {
                                'post_type.raw': postTypes,
                            },
                        });
                    }
                }

                queryJSON.query = JSON.stringify(queryJSON.query);

                let query = this.buildSearchQuery(searchText, placeholder, queryJSON);

                // fetch the results
                const response = await this.esSearch(query, searchText);

                if (response && response._shards && response._shards.successful > 0)
                {
                    const hits = this.checkForOrderedPosts(response.hits.hits, searchText);
                    queryJSON.query = JSON.parse(queryJSON.query);

                    if (hits.length === 0) {
                        this.searchResult = null;
                    } else {
                        this.searchResult = hits;
                    }
                }
                else {
                    this.searchResult = null;
                    queryJSON.query = JSON.parse(queryJSON.query);
                }

                this.setFormIsLoading(false);
            }
            else if (searchText.length === 0) {
                this.searchResult = null;
            }
        }
    }
}
</script>

<style scoped>

</style>
